import { useExitFormDialog } from "@dashboard/components/Form/useExitFormDialog";
import React from "react";

/**
 * Tells the page's exit-form dialog that something outside the page's form
 * would be lost by leaving (unsaved edits in a card that saves itself,
 * uploads in flight), so leaving asks first. Each caller registers as its own
 * form (its own id). The exit dialog only offers "keep editing" or "leave",
 * so the registered submit is a no-op; registration is what makes
 * `setIsDirty` count (the provider ignores an id it has no entry for, and
 * drops every entry on each navigation, hence registering again whenever the
 * flag changes). The provider's own beforeunload listener covers a reload or
 * tab close while the flag is set.
 */
export const useExitGuard = (dirty: boolean) => {
  const { setExitDialogSubmitRef, setIsDirty } = useExitFormDialog();

  React.useEffect(() => {
    setExitDialogSubmitRef(async () => []);
    setIsDirty(dirty);
    // The hook's setters are rebuilt per render; only the flag matters.
  }, [dirty]);

  React.useEffect(
    () => () => {
      setIsDirty(false);
    },
    [],
  );
};
